import React from 'react'
import { Outer } from '../UI/Layout'
import { Link } from 'react-router-dom'

export default function NotFound() {
    return <Outer>
        <div>We couldn't find that page.</div>
        <Link to='/new'>👉</Link>
    </Outer>
}